export enum FulfilledByFaireBenefitsType {
  FULFILLED_BY_FAIRE_BENEFITS_TYPE_UNKNOWN = 'FULFILLED_BY_FAIRE_BENEFITS_TYPE_UNKNOWN',
  FULFILLED_BY_FAIRE_LAUNCH_BENEFITS = 'FULFILLED_BY_FAIRE_LAUNCH_BENEFITS',
}
